/**
 * @NULL hodnota je pouzita jen pro pripad ze nema byt vybrana zadna hodnota
 */
export enum EHlasovani {
    NULL = 'VYBERTE',
    ABST = 'ABST',
    CAGS = 'CAGS',
    AMGT = 'AMGT',
    BLNK = 'BLNK',
    CHRM = 'CHRM',
    DISC = 'DISC',
    CFOR = 'CFOR',
    NOAC = 'NOAC',
    ONEY = 'ONEY',
    THRY = 'THRY',
    TWOY = 'TWOY',
    WTHH = 'WTHH',
    WMGT = 'WMGT'
}
